import SnapsnapGateway from '@/gateways/SnapsnapGateway'
// import { ErrorType, UnprocessableError } from '@/common/errors'

export interface IVerifySignupStoreUseCaseParams {
  snapsnapGateway: SnapsnapGateway
}

export default class VerifySignupStoreUseCase implements BaseUseCase {
  snapsnapGateway: SnapsnapGateway

  constructor({ snapsnapGateway }: IVerifySignupStoreUseCaseParams) {
    this.snapsnapGateway = snapsnapGateway
  }

  async execute(params: { email: string; password: string }) {
    try {
      const registeredStoreName = await this.snapsnapGateway.Auth.verifySignupStore(params)
      return registeredStoreName
    } catch (error) {
      // if (error.status === ErrorType.UNPROCESSABLE) {
      //   throw new UnprocessableError(error.message)
      // }
      throw error
    }
  }
}
